<template>
	<Modal 
	v-if="show"
	:title="'ALTERAR DADOS DA ENTREGA'"
	:loading="loading"
	@close="close"
	@save="save">
		<div class="row card" :class="{'active': change_driver}">
			<div class="col-xs-12">
				<FormCheckbox v-model="change_driver" label="Alterar motorista" icon="fa-id-card" tooltip="Informe se deseja modificar motorista" />
			</div>
			<div class="col-xs-12" v-if="change_driver">
				<FormSelect :options="drivers" v-model="driver" label="Motorista" icon="fa-id-card" tooltip="Selecione o motorista que fará o delivery da entrega" />
			</div>
		</div>
		<div class="row card" :class="{'active': change_license_plate}">
			<div class="col-xs-12">
				<FormCheckbox v-model="change_license_plate" label="Alterar placa" icon="fa-truck" tooltip="Informe se deseja modificar o veículo" />
			</div>
			<div class="col-xs-12" v-if="change_license_plate">
				<FormInput v-model="license_plate" label="Placa do veículo" icon="fa-truck"  tooltip="Informe o veículo que será selecionado para o delivery" />
			</div>
		</div>
		<div class="row card" :class="{'active': change_cargo}">
			<div class="col-xs-12">
				<FormCheckbox v-model="change_cargo" label="Alterar carga" icon="fa-boxes"  tooltip="Informe se deseja modificar a carga"/>
			</div>
			<div class="col-xs-12" v-if="change_cargo">
				<FormInput v-model="cargo" label="Identificação da carga" icon="fa-boxes"  tooltip="Informe a nova carga da entrega" />
			</div>
		</div>
		<div v-if="false" class="row card" :class="{'active': change_observation}">
			<div class="col-xs-12">
				<FormCheckbox v-model="change_observation" label="Alterar observação" icon="fa-info-circle"  tooltip="Informe se deseja modificar a observação"/>
			</div>
			<div class="col-xs-12" v-if="change_observation">
				<FormTextarea v-model="observation" label="Observação" icon="fa-info-circle"  tooltip="Informe a observação que constará na entrega"/>
			</div>
		</div>
	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";
import FormCheckbox from "@/components/FormCheckbox";
import FormTextarea from "@/components/FormTextarea";

export default {
	name: "DeliveryBulkEdit",

	components: {
		FormInput,
		FormSelect,
		FormCheckbox,
		FormTextarea,
		Modal
	},

	props: [
		"show", 
		"list", 
		"drivers"
	],

	data: function() {
		return {
			loading: false,
			change_driver: false,
			driver: '',
			change_license_plate: false,
			license_plate: '',
			change_cargo: false,
			cargo: '',
			change_observation: false,
			observation: '',
		}
	},

	methods: {
		close: function() {
			this.$parent.show_bulk_edit = false;
		},

		reset: function() {
			this.loading = false;
			
			this.change_driver = false;
			this.driver = '';

			this.change_license_plate = false;
			this.license_plate = '';

			this.change_cargo = false;
			this.cargo = '';
			
			this.change_observation = false;
			this.observation = '';
		},

		save: async function() {
			const ids = [...this.list];
			if (ids.length == 0) return;

			let form = {};

			// changes driver
			if (this.change_driver) {
				form['driver_document'] = '';
				form['driver_name'] = '';

				const driver_doc = this.driver;
				if (driver_doc) {
					for (let i in this.$parent.my_drivers) {
						if (this.$parent.my_drivers[i].document == driver_doc) {
							form['driver_document'] = driver_doc;
							form['driver_name'] = this.$parent.my_drivers[i].name;
							form['fk_driver'] = this.$parent.my_drivers[i].id;
							break;
						}
					}
				}
			}


			// changes license plate
			if (this.change_license_plate) {
				form['license_plate'] = '';

				const license_plate = this.license_plate;
				if (license_plate) {
					form['license_plate'] = license_plate;
				}
			}

			// changes cargo id
			if (this.change_cargo) {
				form['cargo'] = this.cargo;
			}
			
			// changes observation
			if (this.change_observation) {
				form['observation'] = this.observation;
			}

			// if nothing changes
			if (Object.keys(form).length == 0) {
				this.close();
				return;
			}

			form['ids'] = ids;

			this.loading = true;
			let res = await Api.upload('delivery/bulk-edit', form);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.$notification.success("Alterado com sucesso.");

			this.$parent.bulk_edit_list.splice(0, this.$parent.bulk_edit_list.length);
			this.reset();
			this.close();
			this.$parent.load();
		}
	}
}
</script>

<style scoped>

.card {
	background: #fafafa;
	margin-bottom: 15px;
	padding: 15px;
	padding-bottom: 0;
	border-radius: 4px;
	max-height: 120px;
	overflow: hidden;
	transition: all 0.4s linear;
}

.card.active {
	max-height: 200px;
	overflow: visible;
}

</style>